<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">数途云</p>
    <p class="address_tel_fax">
      <span>地址：长沙高新开发区岳麓西大道2450号环创园A-4栋606室</span>
      <span>联系电话：18229786622</span>
      <span>客服电话：173-4983-6344</span>
      <span>邮箱：shurankeji@163.com</span>
      <span>公司微信号：shutuyun8801</span>
    </p>
    <span>
      Copyright &copy; 2021 - 2022 长沙数然科技有限公司
      <a class="text-color" href="https://beian.miit.gov.cn" target="_blank">湘ICP备2021019001号-2</a>
    </span>
    <div style="width:300px;margin:0 auto; padding:20px 0;">
		 		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43019002001824" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="@/assets/img/备案图标.png" style="float:left;" alt="湘公网安备"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">湘公网安备 43019002001824号</p>
        </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue